module.exports = __webpack_public_path__ + "static/media/medalla-letra-M_1.9df29e5d.png";